module.exports = __webpack_public_path__ + "img/Right-Arrow.d5920c7e.svg";